<template>
  <v-container
    width="200"
   :class="`pa-1
   map-controls-container
   ${ smallScreen ? 'map-controls-position-mobile' : 'map-controls-position' }
   `">

    <v-row no-gutters>
      <v-col cols="12">
        <v-checkbox
          density="compact"
          :model-value="showGbifData"
          :disabled="!hasSpeciesFilter"
          label="Show GBIF Data"
          persistent-hint
          :hint="hasSpeciesFilter ? 'Species filter active' : 'Requires species filter'"
          @update:model-value="toggleGbifData"
        />
      </v-col>
      <v-col cols="12" class="mt-2">
        <v-checkbox
          density="compact"
          :model-value="showOurData"
          label="Show GenDiB Data"
          hide-details
          @update:model-value="toggleOurData"
        />
      </v-col>
    </v-row>

  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useMetadataStore } from "@/stores/metadataStore";
import { useDisplay } from 'vuetify';

export default defineComponent({
  props: {
    showGbifData: {
      type: Boolean,
      required: true
    },
    showOurData: {
      type: Boolean,
      required: true
    }
  },

  emits: ['update:showGbifData', 'update:showOurData'],

  setup(props, { emit }) {

    const smallScreen = computed(() => {
      const display = useDisplay();
      return display.smAndDown.value;
    });

    // Computed property to check if species filter is active
    const hasSpeciesFilter = computed(() => {
      const mStore = useMetadataStore();
      return mStore.activeFilters && (
        mStore.activeFilters.get('species_group') ||
        mStore.activeFilters.get('species_scientific')
      );
    });

    // Toggle handlers
    const toggleGbifData = (value: boolean | null) => {
      emit('update:showGbifData', value);
    };

    const toggleOurData = (value: boolean | null) => {
      emit('update:showOurData', value);
    };

    return {
      hasSpeciesFilter,
      toggleGbifData,
      toggleOurData,
      smallScreen,
    };
  }
});
</script>

<style scoped>


.map-controls-container {
  position: fixed;
  z-index: 300;
  background-color: white;
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px;
}

.map-controls-position {
  top: 250px;
  right: 0;
}


.map-controls-position-mobile {
  bottom: 0;
  left: 0;
}

.toggle-wrapper {
  display: flex;
  flex-direction: column;
}

.data-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.data-toggle input {
  margin-right: 5px;
}

.info-tooltip {
  font-family: Arial, sans-serif;
  font-size: 11px;
  color: #666;
  margin-left: 20px;
  font-style: italic;
}

.warning {
  color: #c75450;
}
</style>


<style>


.map-controls-position .v-label {
  font-size: 14px;
}

.map-controls-position-mobile .v-label {
  font-size: 13px;
}

</style>
